var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Close "
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2439_25963",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 11,
    height: 10
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close",
    d: "M4.01345 4.96599L0.29148 1.20181C0.0224215 0.929705 0.0224215 0.47619 0.29148 0.204082C0.560538 -0.0680272 1.00897 -0.0680272 1.27803 0.204082L5 3.96825L8.72197 0.204082C8.99103 -0.0680272 9.43946 -0.0680272 9.70852 0.204082C9.97758 0.47619 9.97758 0.929705 9.70852 1.20181L5.98655 4.96599L9.79821 8.82086C10.0673 9.09297 10.0824 9.55207 9.79821 9.81859C9.63644 9.97029 9.34977 10 9.26009 10C9.08072 10 8.90134 9.9093 8.81166 9.81859L5 5.96372L1.18834 9.81859C1.00897 9.9093 0.829596 10 0.650224 10C0.470852 10 0.29148 9.9093 0.201794 9.81859C-0.0672646 9.54649 -0.0672646 9.09297 0.201794 8.82086L4.01345 4.96599Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2439_25963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xF0\x9F\x8E\xA8 Icon color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 -1.25H10V10H0V-1.25Z",
    fill: "#5D5CF5"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Close.55b2338a.svg";
export { ForwardRef as ReactComponent };